<template>
  <hm-content title="">
    <div class="table-panel flex  flex-end">
      <!-- <el-input
        clearable
        style="width: 200px"
        v-model.trim="searchCondition.keyword"
        placeholder="请输入姓名/电话"
        size="small"
        class="ipt mr20"
      ></el-input> -->
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.keyword"
        :placeholder="placeholder"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQueryType"
          v-model="searchCondition.queryType"
        >
          <el-option label="手机号" value="memberMobile"></el-option>
          <el-option label="会员名称" value="memberName"></el-option>
        </el-select>
      </el-input>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.joinDate"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择加入时间段"
        end-placeholder="选择加入时间段"
      ></el-date-picker>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.date"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择分销时间段"
        end-placeholder="选择分销时间段"
      ></el-date-picker>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
      <el-button
        type="success"
        size="small"
        @click="output('queryAllList', '分销账单')"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="joinTime"
          label="加入时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareAgentId"
          label="分销类型"
        >
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.shareAgentId === '' || scope.row.shareAgentId === null
              "
              >分销</span
            >
            <span v-else>代理分销</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="当前状态"
        >
          <template slot-scope="scope">
            {{}}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="到期日期"
        >
          <template slot-scope="scope">
            {{}}
          </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="memberName"
          label="会员名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="电话号码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shareMemberNum"
          label="下级推会员数"
        >
        </el-table-column>
        <el-table-column
          prop="shareOrderNum"
          header-align="center"
          align="center"
          label="分销订单数"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="totalSalesVolume"
          label="分销订单总额"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.totalSalesVolume }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalMoneyProfitAmount"
          label="累计佣金"
        >
          <template slot-scope="scope">
            <span class="primary"
              >{{ scope.row.totalMoneyProfitAmount }}元</span
            >
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="hasGetcashMoneyAmount"
          label="已提现"
        >
          <template slot-scope="scope">
            <span class="primary">{{ scope.row.hasGetcashMoneyAmount }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="allowGetcashMoneyAmount"
          label="可提现"
        >
          <template slot-scope="scope">
            <span class="success"
              >{{ scope.row.allowGetcashMoneyAmount }}元</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="unlockMoneyAmount"
          label="待解锁佣金"
        >
          <template slot-scope="scope">
            <span class="danger">{{ scope.row.unlockMoneyAmount }}元</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <!-- <el-button
                size="small"
                class="blue"
                type="text"
                @click="toDetails(scope.row, 'personal')"
                >个人信息</el-button
              > -->
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="toDetails(scope.row, 'commission')"
                >佣金详情</el-button
              >
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="toDetails(scope.row, 'withdrawal')"
                >提现详情</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1000px"
      :visible.sync="dialogVisible"
    >
      <div class="content">
        <ul class="info-list">
          <li
            class="mb20"
            v-if="detailsType === 'commission' || detailsType === 'withdrawal'"
          >
            <div class="mb20">
              <div class="modal-table mb20">
                <div class="table-header flex">
                  <div class="flex-1">会员姓名</div>
                  <div class="flex-1">分销类型</div>
                  <div class="flex-1">电话号码</div>
                  <div class="flex-1">加入时间</div>
                </div>
                <div class="table-body flex">
                  <div class="flex-1">{{ row.memberName }}</div>
                  <div
                    class="flex-1"
                    v-if="row.shareAgentId === '' || row.shareAgentId === null"
                  >
                    分销
                  </div>
                  <div class="flex-1" v-else>
                    代理分销
                  </div>
                  <div class="flex-1">{{ row.memberMobile }}</div>
                  <div class="flex-1">{{ row.joinTime }}</div>
                </div>
              </div>
            </div>
          </li>
          <li class="mb20" v-if="detailsType === 'personal'">
            <div class="mb20">
              <div class="modal-table mb20">
                <div class="table-header flex">
                  <div class="flex-1">会员姓名</div>
                  <div class="flex-1">手机号</div>
                  <div class="flex-1">性别</div>
                  <div class="flex-1">生日</div>
                  <div class="flex-1">微信昵称</div>
                  <div class="flex-1">首次加入</div>
                </div>
                <div class="table-body flex">
                  <div class="flex-1">{{ row.memberName }}</div>
                  <div class="flex-1">{{ row.memberMobile }}</div>
                  <div class="flex-1">{{ row.memberMobile }}</div>
                  <div class="flex-1">{{ row.memberMobile }}</div>
                  <div class="flex-1">{{ row.memberMobile }}</div>
                  <div class="flex-1">{{ row.joinTime }}</div>
                </div>
              </div>
            </div>
            <div>
              到期日期：
              <el-date-picker
                v-model="row.joinTime"
                type="date"
                placeholder="请选择到期日期"
                value-format="yyyy-MM-dd"
                size="small"
                class="mr10"
              ></el-date-picker
              >调整该处日期即对会员日期进行延期或者缩短。
            </div>
          </li>

          <li class="mb20">
            <div class="title" v-if="detailsType === 'commission'">
              佣金明细
            </div>
            <div class="title" v-if="detailsType === 'withdrawal'">
              提现详情
            </div>
            <div class="title" v-if="detailsType === 'personal'">
              分销权益变动
            </div>
            <div
              v-if="
                detailsType === 'commission' || detailsType === 'withdrawal'
              "
              class="flex  mb10"
              :class="
                detailsType === 'commission' ? 'flex-between' : 'flex-end'
              "
            >
              <div v-if="detailsType === 'commission'">
                <el-radio-group v-model="type" size="small" @change="switchTab">
                  <el-radio-button label="share">分销返佣</el-radio-button>
                  <el-radio-button label="agent">代理奖励</el-radio-button>
                </el-radio-group>
              </div>
              <div>
                <el-date-picker
                  :default-time="['00:00:00', '23:59:59']"
                  class="mr10"
                  size="small"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="searchConditionBill.date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="請选择筛选时段"
                  end-placeholder="請选择筛选时段"
                ></el-date-picker>
                <el-button type="primary" size="small" @click="searchBill"
                  >查询</el-button
                >
              </div>
            </div>
            <el-table
              stripe
              border
              :data="detailsBill"
              size="small"
              v-if="detailsType === 'commission'"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (currentPageDetails - 1) * pageSizeDetails + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSn"
                label="订单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="commissionLevel"
                label="返佣级别"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopMemberName"
                label="下单会员"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="actuallyPrice"
                label="订单金额"
              >
                <template slot-scope="scope">
                  <span class="primary">{{ scope.row.actuallyPrice }} 元</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payTime"
                label="支付时间"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="commissionMoney"
                label="返佣金额"
              >
                <template slot-scope="scope">
                  <span class="primary"
                    >{{ scope.row.commissionMoney }} 元</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="commissionState"
                label="佣金状态"
              >
                <template slot-scope="scope">
                  <span
                    class="success"
                    v-if="scope.row.commissionState === 'use'"
                    >可用</span
                  >
                  <span
                    class="danger"
                    v-if="scope.row.commissionState === 'lock'"
                    >锁定</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-table
              stripe
              border
              :data="detailsBill"
              size="small"
              v-if="detailsType === 'withdrawal'"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (currentPageDetails - 1) * pageSizeDetails + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiveAccount"
                label="提现账户"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashTime"
                label="提现日期"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="returnReceiptSn"
                label="支付流水号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashCommission"
                label="提现金额"
              >
                <template slot-scope="scope">
                  <span>¥{{ scope.row.getcashCommission }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-table
              stripe
              border
              :data="detailsBill"
              size="small"
              v-if="detailsType === 'personal'"
            >
              <el-table-column
                type="index"
                label="序号"
                :index="
                  index =>
                    index + (currentPageDetails - 1) * pageSizeDetails + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="变动类型"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiveAccount"
                label="变动人"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashTime"
                label="变动日期"
              >
              </el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="returnReceiptSn"
                label="变动结果"
              >
              </el-table-column>
            </el-table>
            <div class="hm-pagination">
              <el-pagination
                background
                :total="detailsTotal"
                @current-change="pagingDetails"
                @size-change="handleSizeChangeDetails"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPageDetails"
              ></el-pagination>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" size="small" type="primary">
          关 闭</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      detailsType: "",
      title: "",
      type: "share",
      currentPageDetails: 1,
      pageSizeDetails: 10,
      detailsTotal: 0,
      detailsBill: [],
      dialogVisible: false,
      isOutputing: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      placeholder: "请输入手机号",
      searchCondition: {
        queryType: "memberMobile"
      },
      searchConditionBill: {},
      row: {},
      shareCenterId: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "memberMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "memberName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.payTimeStart = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.payTimeEnd = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      searchCondition.joinTimeStart = this.isArray(searchCondition.joinDate)
        ? searchCondition.joinDate[0]
        : "";

      searchCondition.joinTimeEnd = this.isArray(searchCondition.joinDate)
        ? searchCondition.joinDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryShareMemberOrderList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.payTimeStart = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.payTimeEnd = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      searchCondition.joinTimeStart = this.isArray(searchCondition.joinDate)
        ? searchCondition.joinDate[0]
        : "";

      searchCondition.joinTimeEnd = this.isArray(searchCondition.joinDate)
        ? searchCondition.joinDate[1]
        : "";
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllShareMemberOrderList", params);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryDetailsList() {
      let params = {
        pageNo: this.currentPageDetails,
        pageSize: this.pageSizeDetails,
        shareCenterId: this.shareCenterId
      };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionBill)
      );
      searchCondition.queryStartTime = this.isArray(searchCondition.date)
        ? searchCondition.date[0]
        : "";

      searchCondition.queryEndTime = this.isArray(searchCondition.date)
        ? searchCondition.date[1]
        : "";
      Object.assign(params, searchCondition);
      let name;
      if (this.detailsType === "commission") {
        name = "queryShareCommissionFlowList";
      } else if (this.detailsType === "withdrawal") {
        name = "detailsWithdraw";
      }
      //  let name=
      //   this.detailsType === "commission"
      //     ? "queryShareCommissionFlowList"
      //     : "detailsWithdraw";
      if (this.detailsType === "commission") {
        params.commissionType = this.type;
      } else if (this.detailsType === "withdrawal") {
        params.getcashApprovalState = "pay";
      }
      const { result } = await this.$store.dispatch(name, params);
      if (this.detailsType === "commission") {
        this.detailsBill = result.records;
        this.detailsTotal = result.total;
      } else if (this.detailsType === "withdrawal") {
        this.detailsBill = result.getcashOrders.records;
      }

      //   const { records, total } = result;
      //   this.detailsBill = records;
    },

    toDetails(row, detailsType) {
      this.row = row;
      this.shareCenterId = row.shareCenterId;
      this.currentPageDetails = 1;
      this.pageSizeDetails = 10;
      this.detailsBill = [];
      this.detailsType = detailsType;
      if (detailsType === "commission") {
        this.title = "佣金详情";
      } else if (detailsType === "withdrawal") {
        this.title = "提现详情";
      } else if (detailsType === "personal") {
        this.title = "个人信息";
      }
      this.dialogVisible = true;
      this.queryDetailsList();
    },
    pagingDetails(page) {
      this.currentPageDetails = page;
      this.queryDetailsList();
    },
    handleSizeChangeDetails(size) {
      this.currentPageDetails = 1;
      this.pageSizeDetails = size;
      this.queryDetailsList();
    },
    searchBill() {
      this.currentPageDetails = 1;
      this.queryDetailsList();
    },
    switchTab(val) {
      this.currentPageDetails = 1;
      this.queryDetailsList();
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.records;
            list.forEach(v => {
              if (v.shareAgentId === "" || v.shareAgentId === null) {
                v.shareAgentId = "分销";
              } else {
                v.shareAgentId = "代理分销";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
.info-list {
  .title {
    color: rgba(34, 34, 34, 1);
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    > div {
      padding: 15px;
    }
  }
}
</style>
